import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { User, UserStatusTypes } from '../../models/auth/auth.model'

type AuthState = {
    user: User | null
    guest: boolean

    isLoading: boolean
    error: string

    signUpSuccess: boolean
    statusChanged: UserStatusTypes | null
    resetPasswordCodeSent: boolean
    updateProfileSuccess: boolean
    updatePasswordSuccess: boolean
    updateAddressSuccess: boolean
    updateContactSuccess: boolean
    deleteAccountSuccess: boolean
}

const initialState: AuthState = {
    user: null,
    guest: true,

    isLoading: false,
    error: "",

    signUpSuccess: false,
    statusChanged: null,
    resetPasswordCodeSent: false,
    updateProfileSuccess: false,
    updatePasswordSuccess: false,
    updateAddressSuccess: false,
    updateContactSuccess: false,
    deleteAccountSuccess: false
}

export const AuthSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setIsLoading: (state) => {
            state.isLoading = true;
        },
        signInSuccess: (state, action: PayloadAction<User>) => {
            state.isLoading = false;
            state.user = action.payload;
            state.error = "";
        },
        signUpSuccess: (state) => {
            state.isLoading = false;
            state.signUpSuccess = true;
        },
        setError: (state, action: PayloadAction<string>) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        signInAsGuest: (state) => {
            state.user = null;
            state.guest = true;
            state.error = "";
        },
        statusChanged: (state, action: PayloadAction<User>) => {
            state.statusChanged = action.payload.status;
            state.user = action.payload;
        },
        resetPasswordCodeSent: (state) => {
            state.isLoading = false;
            state.resetPasswordCodeSent = true;
        },
        updateUser: (state, action: PayloadAction<User>) => {
            state.user = action.payload;
            state.isLoading = false;
            state.updateProfileSuccess = true;
        },
        updateAddress: (state, action: PayloadAction<User>) => {
            state.isLoading = false;
            state.user = action.payload;
            state.updateAddressSuccess = true;
        },
        updateContact: (state, action: PayloadAction<User>) => {
            state.isLoading = false;
            state.user = action.payload;
            state.updateContactSuccess = true;
        },
        updatePassword: (state) => {
            state.isLoading = false;
            state.updatePasswordSuccess = true;
        },
        signOutSuccess: (state) => {
            state.isLoading = false;
            state.user = null;
            state.guest = false;
            state.deleteAccountSuccess = false;
            state.error = "";
        },
        deleteAccountSuccess: (state) => {
            state.deleteAccountSuccess = true;
            state.isLoading = false;
        },
        clearState: (state) => {
            state.isLoading = false;
            state.error = "";
            state.signUpSuccess = false;
            state.statusChanged = null;
            state.resetPasswordCodeSent = false;
            state.updateProfileSuccess = false;
            state.updatePasswordSuccess = false;
            state.updateAddressSuccess = false;
            state.updateContactSuccess = false;
            state.deleteAccountSuccess = false;
        },
    },
});

export default AuthSlice.reducer;
export const {
    setIsLoading,
    signInSuccess,
    signUpSuccess,
    setError,
    signInAsGuest,
    statusChanged,
    resetPasswordCodeSent,
    updateUser,
    updateAddress,
    updateContact,
    updatePassword,
    clearState,
    signOutSuccess,
    deleteAccountSuccess,
    
} = AuthSlice.actions;